module.exports = __webpack_public_path__ + "img/overlay-1.50198024.png";